import React, { useContext } from "react";
import Accommodation from "./components/Accommodation";
import { LanguageContext } from "configuration/app-context-manager/LanguageContext";
import Data from "./data/index.json";
import { SectionHeader } from "common/components/SectionHeader";
import { Box } from "@mui/material";

export const Accommodations = () => {
  const { language } = useContext(LanguageContext);

  return (
    <Box>
      {/* Page header */}
      <Box
        sx={{
          mt: 10,
          pb: { xs: 2, md: 3 },
          textAlign: "center",
        }}
      >
        <SectionHeader
          title={Data[language].localAccommodations.title}
          subtitle={Data[language].localAccommodations.subtitle}
        />
      </Box>

      {/* Local accommodations - stacked rows */}
      <Box display="flex" flexDirection="column" gap={{ xs: 0.5, md: 1 }}>
        {Data[language].localAccommodations.accommodations.map((acc, id) => (
          <Accommodation key={id} data={acc} />
        ))}
      </Box>

      {/* Long/medium term section */}
      <Box
        sx={{
          pt: { xs: 6, md: 8 },
          pb: { xs: 2, md: 3 },
          textAlign: "center",
        }}
      >
        <SectionHeader
          title={Data[language].lmtAccommodations.title}
          subtitle={Data[language].lmtAccommodations.subtitle}
        />
      </Box>

      <Box display="flex" flexDirection="column" gap={{ xs: 0.5, md: 1 }} mb={{ xs: 8, md: 12 }}>
        {Data[language].lmtAccommodations.accommodations.map((acc, id) => (
          <Accommodation key={id} data={acc} />
        ))}
      </Box>
    </Box>
  );
};
